import { hasContent } from "../emptiness";
import { ConditionOperatorId } from "./types";
const PATH_PATTERN = /^[^\s!=]+$/;
export const existsOperator = {
    id: ConditionOperatorId.Exists,
    parse({ expression }) {
        if (!PATH_PATTERN.test(expression))
            return undefined;
        return { operatorId: ConditionOperatorId.Exists, path: expression };
    },
    build({ match }) {
        return match.path;
    },
    evaluate({ value }) {
        return hasContent(value);
    },
};
